import { render } from "./Cube.vue?vue&type=template&id=d266ad52"
import script from "./Cube.vue?vue&type=script&lang=js"
export * from "./Cube.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "d266ad52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d266ad52', script)) {
    api.reload('d266ad52', script)
  }
  
  module.hot.accept("./Cube.vue?vue&type=template&id=d266ad52", () => {
    api.rerender('d266ad52', render)
  })

}

script.__file = "src/icons/components/filled/Cube.vue"

export default script